// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.1 1.5H10.9C11.78 1.5 12.5 2.22 12.5 3.1V5.4C12.5 6.28 11.78 7 10.9 7H5.1C4.22 7 3.5 6.28 3.5 5.4V3.1C3.5 2.22 4.22 1.5 5.1 1.5Z',
  'M3.2 9.5H12.8C13.74 9.5 14.5 10.26 14.5 11.2V12.8C14.5 13.74 13.74 14.5 12.8 14.5H3.2C2.26 14.5 1.5 13.74 1.5 12.8V11.2C1.5 10.26 2.26 9.5 3.2 9.5Z',
  'M4.1 12H5.1M8 12H11.9',
];
